import { LicenseInfo } from '@mui/x-license';

// The MUI X Premium license key. It is safe to be public:
// https://mui.com/x/introduction/licensing/#license-key-security
LicenseInfo.setLicenseKey(
	'093406d4011b7b39c98f237bdd016d6dTz0xMzI5ODcsRT0xODIxMDUyNzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'
);
